var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTeamSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.457031,
    y: 32.2715,
    width: 32.0833,
    height: 32.0833,
    rx: 16.0417,
    transform: "rotate(-90 0.457031 32.2715)",
    fill: "#E7EFF9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2941 21.25L18.4216 18.3775C17.8216 18.7675 17.1166 19 16.3516 19C14.2816 19 12.6016 17.32 12.6016 15.25C12.6016 13.18 14.2816 11.5 16.3516 11.5C18.4216 11.5 20.1016 13.18 20.1016 15.25C20.1016 16.015 19.8691 16.72 19.4791 17.3125L22.3516 20.1925L21.2941 21.25ZM18.6016 15.25C18.6016 14.0125 17.5891 13 16.3516 13C15.1141 13 14.1016 14.0125 14.1016 15.25C14.1016 16.4875 15.1141 17.5 16.3516 17.5C17.5891 17.5 18.6016 16.4875 18.6016 15.25Z",
    fill: "#E35205"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamSearch);
export default __webpack_public_path__ + "static/media/teamSearch.3dee1db8a1a20a2f056a0baf8be8c709.svg";
export { ForwardRef as ReactComponent };